/**
 * Módulo para manejar descargas automáticas
 */
(function() {
    'use strict';

    /**
     * Fuerza la descarga de un archivo
     * @param {string} url - URL del archivo a descargar
     */
    function forceDownload(url) {
        // Crear un elemento <a> temporal para forzar la descarga
        const link = document.createElement('a');
        link.href = url;
        link.download = ''; // Esto fuerza la descarga en lugar de navegar
        link.style.display = 'none';
        
        // Añadir al DOM, hacer clic y remover
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    /**
     * Comprueba si hay una URL de descarga forzada y la ejecuta
     */
    function checkForceDownload() {
        // Verificar que existe la configuración global
        if (typeof GesvaltFormulariosConf === 'undefined') {
            return;
        }

        // Verificar que existe la variable force_download_url y tiene valor
        if (GesvaltFormulariosConf.force_download_url && 
            GesvaltFormulariosConf.force_download_url.trim() !== '') {
            
            console.log('Iniciando descarga automática:', GesvaltFormulariosConf.force_download_url);
            
            // Forzar la descarga
            forceDownload(GesvaltFormulariosConf.force_download_url);
            
            // Opcional: limpiar la variable para evitar descargas repetidas
            GesvaltFormulariosConf.force_download_url = '';
        }
    }

    /**
     * Inicializa el módulo de descargas
     */
    function initDownloadModule() {
        // Comprobar descarga forzada cuando la página termine de cargar
        window.addEventListener('load', function() {
            // Pequeño delay para asegurar que todo esté cargado
            setTimeout(checkForceDownload, 100);
        });

        // También comprobar cuando el DOM esté listo (fallback)
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', function() {
                // Solo si window.load no se ha ejecutado aún
                if (document.readyState === 'complete') {
                    setTimeout(checkForceDownload, 100);
                }
            });
        } else {
            // El DOM ya está listo
            if (document.readyState === 'complete') {
                setTimeout(checkForceDownload, 100);
            }
        }
    }

    // Exponer funciones globalmente si es necesario
    window.GesvaltDownload = {
        forceDownload: forceDownload,
        checkForceDownload: checkForceDownload
    };

    // Inicializar el módulo
    initDownloadModule();

})();